export enum UserRoles {
  SUPERADMIN = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export const ROLES = [UserRoles.SUPERADMIN, UserRoles.ADMIN, UserRoles.USER];
